import BuildSubjectDescriptionView from '@/app/private/subjects/views/build-subject/build-subject-description/build-subject-description.view.vue';

export const BUILD_SUBJECT_ROUTES = {
  BUILD_SUBJECT: {
    NAME: 'private.build-subject',
    PATH: 'buildSubject'
  },
  BUILD_SUBJECT_DESCRIPTION: {
    NAME: 'private.build-subject.description',
    PATH: 'description/:id'
  }
};

export const buildSubjectRoutes = [
  { 
    name: BUILD_SUBJECT_ROUTES.BUILD_SUBJECT_DESCRIPTION.NAME,
    path: BUILD_SUBJECT_ROUTES.BUILD_SUBJECT_DESCRIPTION.PATH,
    component: BuildSubjectDescriptionView
  },
  {
    path: '/', redirect: { name: BUILD_SUBJECT_ROUTES.BUILD_SUBJECT_DESCRIPTION.NAME }
  }
];